<template>
  <v-app>
    <v-main>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-card class="elevation-6" width="420">
            <v-toolbar dark color="primary" class="justify-center">
              <v-toolbar-title>{{ $city.name }}政府健檢預約平台</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-alert v-if="!token" type="error" dense outlined>
                設定密碼連結不完整
              </v-alert>
              <v-text-field
                v-model="password"
                prepend-icon="mdi-lock"
                label="新密碼"
                type="password"
                v-on:keyup.enter="submit"
              ></v-text-field>
              <v-text-field
                v-model="confirmPassword"
                prepend-icon="mdi-lock-check"
                label="確認新密碼"
                type="password"
                v-on:keyup.enter="submit"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-btn text color="primary" @click="$router.push('/dashboard')">
                返回登入
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" :disabled="!token" @click="submit">
                設定密碼
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "ActivatePassword",
  data: () => ({
    password: "",
    confirmPassword: "",
  }),
  computed: {
    token() {
      return (this.$route.query.token || "").toString();
    },
  },
  methods: {
    isStrongPassword(password) {
      if (!password || password.length < 8) return false;
      const hasLower = /[a-z]/.test(password);
      const hasUpper = /[A-Z]/.test(password);
      const hasDigit = /[0-9]/.test(password);
      const hasSpecial = /[!@#$%^&*()_+\-=\[\]{}~;':"\\|,.<>\/?]/.test(
        password
      );
      const categories = [hasLower, hasUpper, hasDigit, hasSpecial].filter(
        Boolean
      ).length;
      return categories >= 3;
    },
    async submit() {
      if (!this.token) {
        this.$toast.error("設定密碼連結不完整");
        return;
      }
      if (!this.password || !this.confirmPassword) {
        this.$toast.error("請輸入新密碼與確認密碼");
        return;
      }
      if (this.password !== this.confirmPassword) {
        this.$toast.error("兩次輸入的密碼不一致");
        return;
      }
      if (!this.isStrongPassword(this.password)) {
        this.$toast.error(
          "密碼長度應為8碼(含8碼)以上，包含英文大寫小寫、特殊符號或數字三種以上"
        );
        this.password = "";
        this.confirmPassword = "";
        return;
      }

      this.$vloading.show();
      try {
        await this.axios.post("/dashboard/activate-password", {
          token: this.token,
          password: this.password,
        });
        this.$toast.success("密碼已設定，請重新登入");
        this.$router.push("/dashboard");
      } catch (error) {
        this.$toast.error(error.response?.data?.errMsg || "設定密碼失敗");
      } finally {
        this.$vloading.hide();
      }
    },
  },
};
</script>
